import BaseService from "../../../services/BaseService";

class ActivityService extends BaseService{};

export default new ActivityService('health_backend', 'activities');